(function() {
    'use strict';

    angular
        .module('app.core')
        .run(appRun);

    /* @ngInject */
    function appRun(routerHelper, config) {
        var otherwise = '/'+config.language; //+'/404';
        //var otherwise = '/'+config.language +'/oracle';
        routerHelper.configureStates(getStates(), otherwise);
    }
    function getStates() { return []; }
    //
    //function getStates() {
    //    return [
    //        {
    //            state: '404',
    //            config: {
    //                url: '/404',
    //                templateUrl: 'app/core/404.html',
    //                title: '404'
    //            }
    //        }
    //    ]
    //}
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/core/core.route.js
 ** module id = 154
 ** module chunks = 0
 **/